import { SUPPORT_CENTER_ITEMS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection/PopoutMenuSection";
import { SupportCenterItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterItem/SupportCenterItem";
import { HomeMenuSubItemPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuSubItemPopout/HomeMenuSubItemPopout";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const HomeMenuSupportPopout = ({ onClickBack }: IHomeMenuSupportPopout) => {
  const { data: user } = useUser();
  const userProperties = getUserProperties(user, {
    shouldUseNewUserApi: false,
  });

  return (
    <HomeMenuSubItemPopout
      dataTestId="home-classes-popout"
      onClickBack={onClickBack}
    >
      <PopoutMenuSection width="19.625rem" title="Support">
        {SUPPORT_CENTER_ITEMS.filter((item) =>
          typeof item.enabled === "function"
            ? item.enabled(user, userProperties)
            : item.enabled,
        ).map(({ title, href, openInNewTab, ItemIcon }, index) => (
          <SupportCenterItem
            title={title}
            href={href}
            ItemIcon={ItemIcon}
            openInNewTab={openInNewTab}
            key={index}
          />
        ))}
      </PopoutMenuSection>
    </HomeMenuSubItemPopout>
  );
};

interface IHomeMenuSupportPopout {
  onClickBack: () => void;
}

HomeMenuSupportPopout.displayName = "HomeMenuSupportPopout";
export { HomeMenuSupportPopout };
